export const defaultProfileImg = 'https://i.ibb.co/Zd91Vx4/profile.jpg';
export const profileImg1 = 'https://i.ibb.co/rp47HPT/profile-Img1.png';
export const profileImg2 = 'https://i.ibb.co/Lx53kDc/profile-Img2.png';